export default __webpack_public_path__ + "static/media/clicka-agent.f0241f6c.png";